// @flow
import React, { Component } from 'react';
import { type FailedMerchant } from '../../../../../utilities/types';
import {
  ActionRowTr,
  SpacerTd
} from '../../../../../components/ModelListStyles';
import { Mobile, Device } from '../../../../../components/Responsive';
import {
  RowActionButtonsDiv,
  DeleteRowButton,
  EditRowButton,
  DetailRowDiv
} from './FailedMerchantStyles';
import { DefaultIcon } from '../../../../../components/Icon';

type Props = {
  merchant: FailedMerchant,
  colSpan: number,
  deleteFailedMerchant: (failedMerchantId: number, showModal: ?boolean) => void,
  handleEditClick: (merchant: FailedMerchant) => void
};

export default class FailedMerchantDetailRow extends Component<Props> {
  handleDeleteClick = () => {
    this.props.deleteFailedMerchant(this.props.merchant.id, true);
  };

  handleEditClick = () => {
    this.props.handleEditClick(this.props.merchant);
  };

  render() {
    const { merchant } = this.props;
    return (
      <ActionRowTr>
        <SpacerTd />
        <td colSpan={this.props.colSpan}>
          <DetailRowDiv>
            <Device>
              <h6>Email</h6>
              <p>{merchant.email}</p>
            </Device>
            <Mobile>
              <RowActionButtonsDiv>
                <EditRowButton onClick={this.handleEditClick}>
                  <DefaultIcon name="edit" color="white" /> Edit
                </EditRowButton>
                <DeleteRowButton onClick={this.handleDeleteClick}>
                  <DefaultIcon name="trash" /> Delete
                </DeleteRowButton>
              </RowActionButtonsDiv>
            </Mobile>
          </DetailRowDiv>
        </td>
        <SpacerTd />
      </ActionRowTr>
    );
  }
}
